import { usePriorities } from "../../lib/queries";
import { projectGradientCss } from "../../lib/projectColor";

// "Up Next" rail block — top 10 priorities from the prioritizer agent.
// Aero treatment: glossy gold rank chip, italic-serif title + reason,
// project pill in saturated gradient.
export default function PrioritiesQueue() {
  const { data: priorities = [] } = usePriorities();

  return (
    <div className="mt-3 flex flex-col">
      <div className="flex items-center justify-between px-2 pt-2 pb-1">
        <span
          className="font-eyebrow"
          style={{
            fontSize: 10,
            fontWeight: 800,
            letterSpacing: "0.2em",
            textTransform: "uppercase",
            color: "var(--hot-pink)",
          }}
        >
          ✦ Up Next
        </span>
        <span
          className="font-eyebrow"
          style={{ fontSize: 10, fontWeight: 700, color: "var(--plum)", opacity: 0.6 }}
        >
          {priorities.length}
        </span>
      </div>
      {priorities.length === 0 ? (
        <span
          className="px-2 pb-2 text-xs"
          style={{ fontFamily: "Fraunces, serif", fontStyle: "italic", color: "var(--plum)", opacity: 0.7 }}
        >
          queue is empty — Nigel approves
        </span>
      ) : (
        <div className="flex flex-col gap-1.5 px-1">
          {priorities.map((p) => (
            <div
              key={p.id}
              className="aero-glass aero-glass-tight flex flex-col gap-1 px-3 py-2"
              style={{ borderRadius: 14 }}
            >
              <div className="flex w-full items-start gap-2">
                <span className="gold-rank-chip" style={{ width: 22, height: 22, fontSize: 10 }}>
                  {p.rank}
                </span>
                <span
                  className="flex-1 leading-tight"
                  style={{
                    fontFamily: "Manrope, sans-serif",
                    fontWeight: 700,
                    fontSize: 12.5,
                    color: "var(--ink)",
                  }}
                >
                  {p.title}
                </span>
              </div>
              {p.project ? (
                <span
                  className="glossy-project-pill self-start"
                  style={{ background: projectGradientCss(p.project, 135), marginLeft: 30 }}
                >
                  {p.project}
                </span>
              ) : null}
              {p.reason ? (
                <span
                  className="line-clamp-2"
                  style={{
                    fontFamily: "Fraunces, serif",
                    fontStyle: "italic",
                    fontSize: 11,
                    lineHeight: 1.45,
                    color: "var(--plum)",
                    opacity: 0.78,
                    marginLeft: 30,
                  }}
                >
                  {p.reason}
                </span>
              ) : null}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
